<ng-container *transloco="let t">
  <p-confirmdialog />

  <!-- Use flex with column direction and set a fixed height -->
  <div class="flex flex-col h-full max-h-[80vh]">
    <!-- Content section - scrollable -->
    <div class="flex-1 overflow-y-auto">
      <div class="mb-5">
        <p class="dark:text-surface-400">{{ t("app.organization-settings.editUserDialog.description") }}</p>
      </div>
      <p-fluid>
        <form [formGroup]="form">
          <formly-form [form]="form" [model]="model" [fields]="fields" [options]="options"></formly-form>
        </form>
      </p-fluid>
    </div>

    <!-- Footer section - fixed -->
    <div class="mt-3 pt-3 border-t border-surface-200 dark:border-surface-700">
      <div class="flex flex-row justify-between flex-wrap gap-3 w-full">
        <!-- Left-aligned: Delete button -->
        <div>
          @if (canRemoveUsers) {
            <p-button
              [label]="t('app.common.delete')"
              icon="pi pi-trash"
              variant="outlined"
              severity="danger"
              (click)="openConfirmationDeleteDialog()"
              [disabled]="form.invalid || loading"
              [loading]="this.loading"
            />
          }
        </div>

        <!-- Right-aligned: Cancel and Save buttons -->
        <div class="flex gap-3 justify-end">
          <p-button
            [label]="canModifyUsers ? t('app.common.cancel') : t('app.common.close')"
            severity="secondary"
            (click)="ref.close()"
            [disabled]="loading"
          ></p-button>
          @if (canModifyUsers) {
            <p-button
              [label]="t('app.common.save')"
              (click)="submitEditUserForm()"
              [disabled]="form.invalid || loading"
              [loading]="this.loading"
            ></p-button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>
